import React, { ReactNode } from "react";
import cx from "classnames";

import styles from "./Paragraph.module.scss";

interface Props {
  variant: "p1" | "p2" | "p3",
  children: ReactNode,
  className?: string,
  critical?: boolean,
  mt?: number,
  mb?: number,
};

export function Paragraph({
  children,
  variant,
  className,
  critical,
  mt,
  mb,
}: Props) {
  return (
    <p
      className={cx(styles.Paragraph, className, {
        [styles.p1]: variant === "p1",
        [styles.p2]: variant === "p2",
        [styles.p3]: variant === "p3",
        [styles.critical]: critical,
      })}
      style={{
        marginTop: mt ? `${mt}px` : 0,
        marginBottom: mb ? `${mb}px` : 0,
      }}
    >
      {children}
    </p>
  );
}

